import joinUrl from '../utils/join-url';
import requestUtility from '../helpers/request-utility';
import credentials from '../constants/credentials';

const partnerProductsTree = (apiUrl) => (options, query) => {
  const { partnerId } = options;

  if (!partnerId) {
    throw new Error()
  }

  const url = joinUrl(apiUrl, `/checkoutservice/pb/partners/${partnerId}/products/`);

  return requestUtility.get(url, query, credentials.INCLUDE);
};

export default partnerProductsTree;
